export default __webpack_public_path__ + "static/media/autoconsumo-compensacion.b7ff5cb4.png";